// @tennis-matches/services/trainerstunden/locations
// Service for managing trainerstunden locations

import { loadClubLocations, createClubLocation, updateClubLocation, deleteClubLocation } from "../masterdata/locations.js";

export {
  CLUB_LOCATION_MASTERDATA_SCOPE_SHARED,
  CLUB_LOCATION_MASTERDATA_SCOPE_COACH_DESK,
} from "../masterdata/locations.js";

export { isSharedMasterdataLocation } from "../masterdata/locations.js";

/**
 * Liefert Anzeigename und Kategorie (Indoor/Outdoor) für die Session-Anlage.
 * @param {object|null} session
 * @param {unknown[]} locations
 * @returns {{ name: string, kind: 'indoor'|'outdoor'|'other'|null }}
 */
/**
 * Effektiver Tenant für eine Session: Anlage (`location_id`) schlägt `session.tenant_id`,
 * damit Wetter/Vereinslabel zum tatsächlichen Standort passen (nicht zu veraltetem tenant_id).
 *
 * @param {object|null} session
 * @param {unknown[]} locations
 * @returns {string|null}
 */
export function resolveSessionTenantId(session, locations) {
  const nz = (v) => String(v ?? "").trim();
  let loc = null;
  if (session?.location_id) {
    loc = (locations || []).find((l) => String(l?.id) === String(session.location_id)) || null;
  }
  const fromLoc = loc?.tenant_id ? nz(loc.tenant_id) : "";
  if (fromLoc) return fromLoc;
  const fromSession = session?.tenant_id ? nz(session.tenant_id) : "";
  return fromSession || null;
}

export function resolveSessionLocationVenue(session, locations) {
  const nz = (v) => String(v ?? "").trim();
  let loc = null;
  if (session?.location_id) {
    loc = (locations || []).find((l) => String(l?.id) === String(session.location_id)) || null;
  }
  const name = loc ? nz(loc.name) || nz(session?.location) : nz(session?.location);
  const lt = String(loc?.location_type || "").toLowerCase();
  let kind = null;
  if (lt === "indoor" || lt === "clubhouse") kind = "indoor";
  else if (lt === "outdoor" || lt === "training_site") kind = "outdoor";
  else if (lt) kind = "other";
  return { name, kind };
}

/**
 * Resolves the display label for a session's location.
 * Looks up session.location_id in the locations array, falls back to session.location (free-text).
 * @param {Object} session
 * @param {Array} locations
 * @returns {string}
 */
export function resolveLocationLabel(session, locations) {
  const nz = (v) => String(v ?? "").trim();
  if (session?.location_id) {
    const loc = (locations || []).find((l) => String(l?.id) === String(session.location_id));
    return nz(loc?.name) || nz(session?.location);
  }
  return nz(session?.location);
}

/**
 * Load all locations for the current user
 * @returns {Promise<{ok: boolean, data?: Array, error?: any}>}
 */
export async function loadLocations() {
  return await loadClubLocations();
}

/**
 * Create a new location
 * @param {Object} location - Location data
 * @returns {Promise<{ok: boolean, data?: Object, error?: any}>}
 */
export async function createLocation(location) {
  return await createClubLocation(location);
}

/**
 * Update a location
 * @param {string} id - Location ID
 * @param {Object} updates - Fields to update
 * @returns {Promise<{ok: boolean, data?: Object, error?: any}>}
 */
export async function updateLocation(id, updates) {
  return await updateClubLocation(id, updates);
}

/**
 * Delete a location
 * @param {string} id - Location ID
 * @returns {Promise<{ok: boolean, error?: any}>}
 */
export async function deleteLocation(id) {
  return await deleteClubLocation(id);
}
